





























































































































































import { Component, Vue } from 'vue-property-decorator';
import { IssueService } from "@/services/issue-service";
import {Issue} from "@/models/issue";
import moment from "moment";
import BarChart from "@/components/BarChart.vue";
import IssueDetails from "@/components/IssueDetails.vue"
import {Project} from "@/models/project";
import {ProjectService} from "@/services/project-service";

@Component({
    name: 'ProjectIssuesList',
    components: {
        BarChart,
        IssueDetails
    }
})
export default class ProjectIssuesList extends Vue {

    fields: object[] = [
        {key: 'tracker', label: 'Tracker', tdClass: 'td-bold', sortable: true},
        {key: 'status', label: 'Status', sortable: true},
        {key: 'author', label: 'Author', sortable: true},
        {key: 'assigned_to', label: 'Assigned to', sortable: true},
        {key: 'subject', label: 'Subject'},
        {key: 'estimated_hours', label: 'Estimated hours', sortable: true},
        {key: 'spent_hours', label: 'Spent hours', sortable: true},
        {key: 'hours_left', label: 'Hours left', sortable: true},
        {key: 'expected_hours', label: 'Expected hours', sortable: true},
        {key: 'version', label: 'Version', sortable: true},
        {key: 'done_ratio', label: 'Done', sortable: true},
        {key: 'wps', label: 'WPS', sortable: true},
        {key: 'updated_on', label: 'Updated on', sortable: true},
        {key: 'details', label: 'Details'}
    ];

    totalRows = 1;
    currentPage = 1;
    perPage = 10;
    pageOptions = [10, 15, 25];
    sortBy = 'updated_on';
    sortDesc = true;
    sortDirection = 'asc';
    filter = null;

    chart_progress_data: object = {};
    chart_spentHours_data: object = {};
    chart_hoursLeft_data: object = {};
    chart_eff03_data: object = {};
    chart_eff04_data: object = {};
    chart_eff05_data: object = {};

    project_eff_05 = 0;
    bug_total_hours = 0;
    issues: Array<Issue> = new Array<Issue>();
    histories: Array<Project> = new Array<Project>();

    issue_service: IssueService = new IssueService();
    project_service: ProjectService = new ProjectService();

    constructor() {
        super();
    }

    created () {
        this.getProjectIssues();
        this.getProjectHistory();
    }

    activated() {
        this.getProjectIssues();
        this.getProjectHistory();
    }

    getProjectIssues() {
        this.issues = new Array<Issue>();
        this.issue_service.getProjectIssues(this.$route.params.id)
        .then((response) => {
            this.issues = response.data;
            this.computeEff05();
        })
    }

    get cptIssues() {
        if (this.issues) {
            const issues = this.issues.filter((issue: Issue) => {
                return issue.parent_id == "";
            }).map((issue: Issue) => {
                const tmpIssue = issue;
                tmpIssue._cellVariants = {};
                if (tmpIssue.spent_hours > tmpIssue.estimated_hours) {
                    tmpIssue._cellVariants.spent_hours = "danger";
                    if (tmpIssue.tracker === 'Task' && tmpIssue.estimated_hours > 10) {
                        tmpIssue._cellVariants.estimated_hours = "danger";
                    }
                }
                if (tmpIssue.hours_left && tmpIssue.expected_hours && tmpIssue.expected_hours > tmpIssue.hours_left)
                    tmpIssue._cellVariants.expected_hours = "danger";
                if (tmpIssue.tracker === 'Bug' && tmpIssue.spent_hours)
                    this.bug_total_hours += parseInt(tmpIssue.spent_hours.toFixed(2))
                return tmpIssue
            })
            this.totalRows = issues.length;
            return issues;
        }

        return this.issues;
    }

    getProjectHistory() {
        this.histories = new Array<Project>();
        this.project_service.getProjectHistory(this.$route.params.id)
            .then((response) => {
                if (response.data)
                    this.fillChartData(response.data);
            })
    }

    fillChartData(histories: Array<Project>) {
        this.chart_progress_data = {
            labels: histories.map(history => moment(history.sampled_on).format("YYYY-MM-DD")),
            datasets: [
                {
                    label: 'Progresses',
                    fill: false,
                    borderColor: function () {
                        return histories.map(history => history.done_ratio == 100 ? '#5DAB1B' : '#FFA533')
                    },
                    data: histories.map(history => history.done_ratio)
                }
            ]
        };
        this.chart_spentHours_data = {
            labels: histories.map(history => moment(history.sampled_on).format("YYYY-MM-DD")),
            datasets: [
                {
                    label: 'Spent Hours',
                    borderColor: '#3361FF',
                    data: histories.map(history => history.spent_hours)
                },
                {
                    label: 'Hours Left',
                    backgroundColor: '#D0F6FF',
                    data: histories.map(history => history.hours_left)
                },
                {
                    label: 'Total Estimated',
                    borderColor: '#FC5656',
                    fill: false,
                    data: histories.map(history => history.estimated_hours)
                }
            ]
        };
        this.chart_hoursLeft_data = {
            labels: histories.map(history => moment(history.sampled_on).format("YYYY-MM-DD")),
            datasets: [
                {
                    label: 'Hours Left',
                    backgroundColor: '#D0F6FF',
                    data: histories.map(history => history.hours_left)
                }
            ]
        };
        this.chart_eff03_data = {
            labels: histories.map(history => moment(history.sampled_on).format("YYYY-MM-DD")),
            datasets: [
                {
                    label: 'EFF_03',
                    backgroundColor: function (context: any) {
                        const index = context.dataIndex;
                        const value = context.dataset.data[index];
                        return value ? value >= 200 ? '#7E7E7E' : value >= 150 ? '#B82507' : value >= 100 ? '#EAA00B' : value >= 80 ? '#EBEB00' : '#5DAB1B' : false;
                    },
                    data: histories.map(history => history.eff_03)
                }
            ]
        };
        this.chart_eff04_data = {
            labels: histories.map(history => moment(history.sampled_on).format("YYYY-MM-DD")),
            datasets: [
                {
                    label: 'EFF_04',
                    backgroundColor: function (context: any) {
                        const index = context.dataIndex;
                        const value = context.dataset.data[index];
                        return value ? value >= 200 ? '#7E7E7E' : value >= 150 ? '#B82507' : value >= 100 ? '#EAA00B' : value >= 80 ? '#EBEB00' : '#5DAB1B' : false;
                    },
                    data: histories.map(history => history.eff_04)
                }
            ]
        };
        this.chart_eff05_data = {
            labels: histories.map(history => moment(history.sampled_on).format("YYYY-MM-DD")),
            datasets: [
                {
                    label: 'EFF_05',
                    backgroundColor: '#B82507',
                    data: histories.map(history => history.eff_05)
                }
            ]
        };
    }

    computeEff05() {
        this.project_eff_05 = 0;
        let total_estimated_hours_previous_week = 0;
        let total_estimated_hours_current_week = 0;
        const today = moment().toISOString();
        const last_day_previous_week = moment().subtract(1, 'weeks').endOf('week').toISOString();
        this.issues.forEach((issue: Issue) => {
            if (!issue.estimated_hours)
                return;
            if (moment(issue.updated_on).isBefore(last_day_previous_week)) {
                total_estimated_hours_previous_week += issue.estimated_hours;
            } else if(moment(issue.updated_on).isBetween(last_day_previous_week, today)) {
                total_estimated_hours_current_week += issue.estimated_hours
            }
        });
        total_estimated_hours_current_week += total_estimated_hours_previous_week;
        this.project_eff_05 = total_estimated_hours_current_week - total_estimated_hours_previous_week
    }

}
